export const DEFAULT_USER_PACKAGE = "package/standard";
export const DEFAULT_ADMIN_PACKAGE = "admin/regular";
export const SEMI_DEUS_PACKAGE = "admin/semideus";
export const FREE_PACKAGE = "package/free";
